import { Link } from "react-router-dom";
import logo from "@/assets/frequent-health-logo.jpeg";

export default function MarketingFooter() {
  return (
    <footer className="bg-dark-bg border-t border-primary/10">
      <div className="container mx-auto px-4 sm:px-6 py-10 sm:py-12">
        <div className="flex flex-col items-center gap-8 md:flex-row md:justify-between">
          <a href="/" className="flex items-center space-x-2 shrink-0">
            <img
              src={logo}
              alt="Frequent Health logo"
              className="h-12 w-auto"
            />
          </a>

          <nav className="w-full md:w-auto flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
            <Link
              to="/onboarding"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              Get Started
            </Link>
            <Link
              to="/how-it-works"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              How It Works
            </Link>
            <Link
              to="/pricing"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              Pricing
            </Link>
            <Link
              to="/contact"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              Contact
            </Link>
            <Link
              to="/terms"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              Terms
            </Link>
            <Link
              to="/privacy"
              className="text-sm sm:text-base text-gray-light hover:text-primary transition-colors py-2 px-2 -mx-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              Privacy
            </Link>
          </nav>
        </div>

        <div className="mt-8 pt-8 border-t border-primary/10">
          <p className="text-gray-light text-sm text-center">
            &copy; 2024 Frequent Health. Where Consistency Becomes Power.
          </p>
        </div>
      </div>
    </footer>
  );
}
